export default __webpack_public_path__ + "static/media/logo-white-fr.fad11f59.svg";